import { Component, input } from '@angular/core';
import { PipesModule } from '@digipay/ng-lib-pipes';
import { IPortfolioDetail } from '../../../../../components/core/models/user-fund-assets.interface';
import { DecimalPipe, NgClass } from '@angular/common';

@Component({
  selector: 'app-fund-profile-user-assets',
  standalone: true,
  imports: [PipesModule, DecimalPipe, NgClass],
  templateUrl: './fund-profile-user-assets.component.html',
  styleUrl: './fund-profile-user-assets.component.scss',
})
export class FundProfileUserAssetsComponent {
  asset = input.required<IPortfolioDetail>();
}
